


















































































































































































import {
    MCheckbox,
    MDialog,
    MLink,
    MMessage,
    MModal,
    MPanel,
    MRichText,
    MTextfield,
} from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";
import { Casier } from "../models/Casier";
import { Niveau } from "../models/Niveau";
import { Pavillon } from "../models/Pavillon";
import { Periode } from "../models/Periode";
import { TypeClientele } from "../models/TypeClientele";
import router from "../router";
import store, { modules } from "../store";

Vue.filter("formatDevise", function (montant: number) {
  return Intl.NumberFormat("fr-CA", {
    currency: "CAD",
    style: "currency",
  }).format(montant);
});

@Component({
  components: {
    MMessage,
    MTextfield,
    MPanel,
    MCheckbox,
    MLink,
    MModal,
    MRichText,
    MDialog,
    BoutonsNavigation,
  },
})
export default class Revision extends Vue {
  private indicateurCourrielConfirme: boolean = true;
  private indicateurCourrielValide: boolean = false;
  private afficherConfirmationPerteVerrou: boolean = false;
  private courriel: string = this.recupererCourriel();
  private courrielConfirmation: string = this.recupererCourriel();

  private async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.activerPrecedent.name);

    await store.dispatch(modules.minuteur.actions.demarrerMinuteur.name, {
      delaiVerrou: this.delaiVerrou,
    });

    store.commit(
      modules.utilisateur.mutations.sauvegarderMontant.name,
      this.montantTotal
    );
  }

  async navPrecedent(): Promise<void> {
    // Retrait du verrou si nécessaire
    if (this.casier !== null) {
      await store.dispatch(modules.cds.actions.retirerVerrouUtilisateur.name, {
        vm: this,
        idCasier: this.casier.id,
      });
    }

    store.commit(modules.minuteur.mutations.arreterMinuteurSucces.name);

    const route: string = await store.dispatch(
      modules.trainProgression.actions.etapePrecedente.name
    );
    router.push({ name: route });
  }

  private afficherPopUpPerteVerrou(): void {
    this.afficherConfirmationPerteVerrou = true;
  }

  private recupererCourriel(): string {
    return this.$msal.data.query.profile?.mail || "";
  }

  private allerAuPaiementPermis(): boolean {
    return (
      this.indicateurModalitesAcceptees &&
      this.indicateurCourrielConfirme &&
      this.indicateurCourrielValide
    );
  }

  get indicateurModalitesAcceptees(): boolean {
    return store.state.utilisateur.acceptationModalites || false;
  }

  set indicateurModalitesAcceptees(indicateur: boolean) {
    store.commit(
      modules.utilisateur.mutations.sauvegarderAcceptationModalites.name,
      indicateur
    );

    if (this.allerAuPaiementPermis()) {
      store.commit(modules.trainProgression.mutations.activerSuivant.name);
    } else {
      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
    }
  }

  private estCourrielsIdentiques(): boolean {
    this.indicateurCourrielConfirme =
      this.courriel === this.courrielConfirmation && this.courriel.length > 0;

    if (this.indicateurCourrielConfirme === false) {
      // Dans le cas où le courriel est invalide, on l'efface du state.
      store.commit(
        modules.utilisateur.mutations.sauvegarderCourriel.name,
        null
      );
    }

    if (this.allerAuPaiementPermis()) {
      store.commit(modules.trainProgression.mutations.activerSuivant.name);
      store.commit(
        modules.utilisateur.mutations.sauvegarderCourriel.name,
        this.courriel
      );
    } else {
      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
    }

    return this.indicateurCourrielConfirme;
  }

  private estCourrielValide(): boolean {
    // TODO: Voir à utiliser une librairie ou se définir un utilitaire
    const regexp = new RegExp(
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    this.indicateurCourrielValide = regexp.test(this.courriel);

    if (this.indicateurCourrielValide === false) {
      // Dans le cas où le courriel est invalide, on l'efface du state.
      store.commit(
        modules.utilisateur.mutations.sauvegarderCourriel.name,
        null
      );
    }

    if (this.allerAuPaiementPermis()) {
      store.commit(modules.trainProgression.mutations.activerSuivant.name);
      store.commit(
        modules.utilisateur.mutations.sauvegarderCourriel.name,
        this.courriel
      );
    } else {
      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
    }

    return this.indicateurCourrielValide;
  }

  get modalitesLocation(): string {
    let donnee: string = "";

    const parametre = store.state.cds.parametresPilotage.find(
      (parametre) =>
        parametre.nomParametre ===
        store.state.applicatif.pilotageCleModalitesLocation
    );

    if (parametre !== undefined) {
      donnee = parametre.valeurTexteLong;
    }

    return donnee;
  }

  // TODO: Refactor (utilisé ailleurs)
  get delaiVerrou(): string | null {
    // Obtenir la clé de la définition de la variable d'environnement
    const definitionsVariable = store.state.cds.definitionsVariablesEnv.find(
      (definition) =>
        definition.nomVariableEnv ===
        store.state.applicatif.variableEnvCleDelaiVerrou
    );

    if (definitionsVariable !== undefined) {
      // Obtenir la valeur de la variable d'environnement pour le courriel
      const valeursVariable = store.state.cds.valeursVariablesEnv.find(
        (variableEnv) => variableEnv.definitionId === definitionsVariable.id
      );

      if (valeursVariable !== undefined) {
        return valeursVariable.valeur;
      }
    }

    return null;
  }

  get typeClientele(): TypeClientele | null {
    return store.state.utilisateur.typeClientele;
  }

  get nomTypeClientele(): string {
    return this.typeClientele?.nomTypeClientele || "";
  }

  get taxableTypeClientele(): boolean {
    return this.typeClientele?.taxable || false;
  }

  get periode(): Periode | null {
    return store.state.utilisateur.periode;
  }

  get nomPeriode(): string {
    return this.periode?.nomPeriode || "";
  }

  get tauxTPSPeriode(): number {
    return this.periode?.tauxTPS || 0;
  }

  get tauxTVQPeriode(): number {
    return this.periode?.tauxTVQ || 0;
  }

  get tarifPeriode(): number {
    return this.periode?.tarifLocation || 0;
  }

  get pavillon(): Pavillon | null {
    return store.state.utilisateur.pavillon;
  }

  get nomPavillon(): string {
    return this.pavillon?.nomPavillon || "";
  }

  get niveau(): Niveau | null {
    return store.state.utilisateur.niveau;
  }

  get nomNiveau(): string {
    return this.niveau?.nomNiveau || "";
  }

  get casier(): Casier | null {
    return store.state.utilisateur.casier;
  }

  get numeroCasier(): string {
    return this.casier?.numero || "";
  }

  get montantTPS(): number {
    return this.arrondirMontant(
      this.typeClientele && this.periode && this.taxableTypeClientele
        ? this.tauxTPSPeriode * this.tarifPeriode
        : 0.0
    );
  }

  get montantTVQ(): number {
    return this.arrondirMontant(
      this.typeClientele && this.periode && this.taxableTypeClientele
        ? this.tauxTVQPeriode * this.tarifPeriode
        : 0.0
    );
  }

  get montantTotal(): number {
    return this.arrondirMontant(
      this.periode ? this.montantTPS + this.montantTVQ + this.tarifPeriode : 0.0
    );
  }

  private arrondirMontant(montant: number): number {
    return Math.round(montant * 100) / 100;
  }
}
